import Order from "@/model/Order";
import Employee from "@/model/Employee";

export default class Worklog {
  public id: number;

  public uuid?: string;

  public date: string;

  public start: string;

  public end: string;

  public worklogType: string;

  public comment: string;

  public order: Order | null;

  public employee: Employee | null;

  // Who recorded the worklog and when, as GET /v3/orders/{orderId}/worklogs returns it
  public createdBy?: string;
  public createdAt?: string;
}
